module.exports = __webpack_public_path__ + "img/kf.80da14f2.jpg";